<div>
    No claims for this user
</div>